import {
  Modal,
  Form,
  InputNumber,
  Icons,
  Space,
  TextField,
} from '@pankod/refine-antd'
import React from 'react'

export type ModalFormProgramDurationProps = {
  modalProps: any
  formProps: any
  onSubmit?: () => void
}

export const ModalFormProgramDuration = (
  props: ModalFormProgramDurationProps,
) => {
  const { modalProps, formProps } = props
  return (
    <Modal
      {...modalProps}
      title="Konfigurasi Target Durasi"
      okText="Simpan"
      cancelText="Kembali"
      width={500}
    >
      <Form
        {...formProps}
        layout="vertical"
        validateMessages={{ required: '${label} must be filled.' }}
        initialValues={formProps?.initialValues?.data}
      >
        <Form.Item
          label="Target Durasi Timespend"
          name="async"
          required
          rules={[{ required: true }]}
          getValueProps={(value) => ({ value: Math.round(+value / 60) })}
          getValueFromEvent={(value) => +value * 60}
        >
          <InputNumber
            style={{ width: '250px' }}
            addonBefore={
              <Space>
                <Icons.ClockCircleOutlined />
                <TextField value="Async" />
              </Space>
            }
            addonAfter={'menit'}
            min={0}
            controls={false}
            precision={0}
          />
        </Form.Item>
        <Form.Item
          label="Target Durasi Recording"
          name="sync"
          required
          rules={[{ required: true }]}
          getValueProps={(value) => ({ value: Math.round(+value / 60) })}
          getValueFromEvent={(value) => +value * 60}
        >
          <InputNumber
            style={{ width: '250px' }}
            addonBefore={
              <Space>
                <Icons.ClockCircleOutlined />
                <TextField value="Sync" />
              </Space>
            }
            addonAfter={'menit'}
            min={0}
            controls={false}
            precision={0}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
